import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import Layout from 'components/layout';
import { NavBar, PopupRedirect } from 'components';
import Career from 'views/career';
import { pages } from 'config/pages';
import config from '../../meta/config';

class CareerPage extends Component {
  render() {
    const { edges: offers } = this.props.data.allMarkdownRemark || {};
    const page = pages.career;
    const { navColors } = page;
    const canonical = `${config.siteUrl}/career/`;

    return (
      <Layout {...{page, canonical}}>
        <Helmet title="Career">
          <meta
            name={'description'}
            content={
              'At Boldare you are not just a developer or a designer. You create stunning digital products and are able to make your career thrive. See all the open positions and apply!'
            }
          />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <NavBar color={navColors} />
        <PopupRedirect message={'career'} />
        <Career offers={offers} />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query CareerPage {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___mainContent___promoted] }
      filter: {
        frontmatter: {
          templateKey: { eq: "job-offer-page" }
          mainContent: { archived: { eq: false } }
        }
      }
    ) {
      ...markdownFields
      ...boxMarkdownFields
      edges {
        node {
          frontmatter {
            mainContent {
              archived
              name
              promoted
              city
              salary
              salary2ndLine
              banner
              technical {
                skill
              }
              additional {
                skill
              }
              specifics {
                specific
              }
              photo
              steps {
                number
                step
                details
              }
            }
          }
        }
      }
    }
  }
`;

export default CareerPage;
